import { makeAutoObservable, values } from "mobx";
import * as language from "../utils/language.js";
import * as navigation from "../utils/navigation.js";
import { active } from "d3";

class GlobalVars {
  //========================================================================
  // http-Port
  httpPort = 8040;

  setHttpPort(newHttpPort) {
    this.httpPort = newHttpPort;
  }

  //========================================================================
  // Sprache
  language = "de";

  setLanguage(newLanguage) {
    this.language = newLanguage;
    // Namen im Browser-Tab aktualisieren
    document.title = language.displayText(
      this.pageProperties.currentPageConfig.pageTitle,
    );
    // Startseite nach Sprachwechsel aufrufen
    /*
    if (!this.mobile) {
      navigation.changePage("home");
    } else {
      navigation.changePage("homeMobile");
    }
    */
  }

  //========================================================================
  // Seitenhistorie
  pageHistory = [];

  setPageHistory(newHistory) {
    // verhindere zwei gleiche Einträge hintereinander
    if (newHistory.length > 1) {
      if (
        newHistory[newHistory.length - 1] === newHistory[newHistory.length - 2]
      ) {
        newHistory.pop();
      }
    }

    // verhindere zurück zu Login-Seite
    if (newHistory[newHistory.length - 1] === "__system/login") {
      newHistory.pop();
    }

    this.pageHistory = newHistory;
  }

  //========================================================================
  // Seiteneigenschaften
  pageProperties = {
    currentPageConfig: {
      pageTitle: ["", "", ""],
      forward: "",
      backward: "",
      backgroundImage: "",
      backgroundColor: "",
      showStartImage: false,
      mobile: false,
      elements: [],
    },
    showButtonNavigateForward: false,
    showButtonNavigateBackward: false,
  };

  setPageProperties(newPageProperties) {
    this.pageProperties = newPageProperties;
  }

  //========================================================================
  // Startseite geladen
  startpageLoaded = false;

  setStartpageLoaded(newStartpageLoaded) {
    this.startpageLoaded = newStartpageLoaded;
  }

  //========================================================================
  // Seiten-Skalierung
  scaleFactor = 1;

  setScaleFactor(newScaleFactor) {
    this.scaleFactor = newScaleFactor;
  }

  //========================================================================
  // Seiten-Größe
  pageSize = { width: "1920px", height: "1010px" };

  setPageSize(newPageSize) {
    this.pageSize = newPageSize;
  }

  //========================================================================
  // Uhrzeit und Datum
  dateTime = {};

  setDateTime(newDateTime) {
    this.dateTime = newDateTime;
  }

  //========================================================================
  // blinkendes Alarm-Icon
  alarmActive = false;

  setAlarmActive(newAlarmActive) {
    this.alarmActive = newAlarmActive;
  }

  //========================================================================
  // aktive Alarme
  activeAlarms = [];

  setActiveAlarms(newActiveAlarms) {
    this.activeAlarms = newActiveAlarms;
  }

  //========================================================================
  // archivierte Alarme
  archivedAlarms = [];

  setArchivedAlarms(newArchivedAlarms) {
    this.archivedAlarms = newArchivedAlarms;
  }

  //========================================================================
  // Alarmkonfiguration
  alarmConfig = [];

  setAlarmConfig(newAlarmConfig) {
    this.alarmConfig = newAlarmConfig;
  }

  //========================================================================
  // Benutzer
  users = [];

  setUsers(newUsers) {
    this.users = newUsers;
  }

  //========================================================================
  // Benutzereigenschaften
  auth = {};

  setAuth(newAuth) {
    this.auth = newAuth;
  }

  //========================================================================
  // Websocket-Verbindung
  ws = null;

  setWs(newWs) {
    this.ws = newWs;
  }

  //========================================================================
  // aktuell anzuzeigende Daten
  reqDataValues = [];

  setReqDataValues(newReqDataValues) {
    this.reqDataValues = newReqDataValues;
  }

  //========================================================================
  // empfangene Live-Daten
  rcvValues = [];

  setRcvValues(newRcvValues) {
    this.rcvValues = newRcvValues;
  }

  //========================================================================
  // zyklisches aktualisieren der grafischen Elemente
  updateElementsTrigger = 0;

  setUpdateElementsTrigger(newUpdateElementsTrigger) {
    this.updateElementsTrigger = newUpdateElementsTrigger;
  }

  //========================================================================
  // cyclicUpdate aktiv
  cyclicUpdate = false;

  setCyclicUpdate(newCyclicUpdate) {
    this.cyclicUpdate = newCyclicUpdate;
  }

  //========================================================================
  // Editor aktiv
  editor = false;

  setEditor(newEditor) {
    this.editor = newEditor;
  }

  //========================================================================
  // Startseite
  startpage = "startpage";

  setStartpage(newStartpage) {
    this.startpage = newStartpage;
  }

  //========================================================================
  // Startseite mobil
  startpageMobile = "startpageMobile";

  setStartpageMobile(newStartpageMobile) {
    this.startpageMobile = newStartpageMobile;
  }

  //========================================================================
  // mobile aktiv
  mobile = false;

  setMobile(newMobile) {
    this.mobile = newMobile;
  }

  //========================================================================
  //========================================================================
  //========================================================================
  // Constructor
  constructor() {
    makeAutoObservable(this);
  }
}

export const globalVars = new GlobalVars();
